import axios from "axios";
import app from "../_app";

const productAddToCartPopup = document.querySelector('.js-product-add-to-cart-popup');

let calculateUntilFreeShipping = data => {
    if(productAddToCartPopup) {
        const priceElement = productAddToCartPopup.querySelector('.js-product-add-to-cart-popup-until-free-shipping');

        if(priceElement) {
            if(data.items_subtotal_price < 5000) {
                priceElement.innerText = app.currency(5000 - data.items_subtotal_price);
            } else {
                priceElement.parentNode.remove();
            }
        }
    }
};

export const openProductAddToCartPopup = data => {
    if(productAddToCartPopup) {
        app.lockBody();
        productAddToCartPopup.setAttribute('data-open', '');

        calculateUntilFreeShipping(data);

        return true;
    }

    return false;
};

export const closeProductAddToCartPopup = () => {
    if(productAddToCartPopup) {
        productAddToCartPopup.removeAttribute('data-open');
        app.unlockBody();

        return true;
    }

    return false;
}

if(productAddToCartPopup) {
    const products = [...productAddToCartPopup.querySelectorAll('.js-product-add-to-cart-popup-product')];
    const closeTriggers = [...productAddToCartPopup.querySelectorAll('.js-product-add-to-cart-popup-close')];
    const microcartCount = document.querySelector('.js-microcart-count');

    const addToCart = async e => {
        e.preventDefault();

        const product = e.currentTarget;
        product.setAttribute('data-state', 'loading');

        let response = await axios.post(`${window.Shopify.routes.root}cart/update.js`, {updates: {[product.dataset.vid]: 1}});

        if(response.status === 200) {
            calculateUntilFreeShipping(response.data);
            microcartCount.setAttribute('data-count', response.data.items.length);

            product.setAttribute('data-state', 'done');
            product.removeEventListener('click', addToCart);
        }
    }

    products.map(product => product.addEventListener('click', addToCart));
    closeTriggers.map(closeTrigger => closeTrigger.addEventListener('click', closeProductAddToCartPopup));
}
